// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"96124e80","338":"eac45650","490":"4ebce6f5","515":"a835a196","526":"d241781e","627":"431f886d","717":"0a870486","925":"532036e8"}[chunkId] + ".chunk.js";
};